import { pipe } from 'fp-ts/function';
import { array } from 'fp-ts';
import { RateType } from '@mews-commander/data-access';
import { values } from '@mews/fp';
import { FormSelectField, LocalizedText, useLocalizeEnum } from '@mews/framework';
import { DropdownItem } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { DetailsFieldName } from '../types';

export const VisibilityField = () => {
    const localizeEnum = useLocalizeEnum();

    const rateTypeValues = pipe(
        RateType,
        values,
        array.filter((value) => value !== RateType.AvailabilityBlock)
    );

    const renderRateTypeItems = () =>
        pipe(
            rateTypeValues,
            array.map((value) => <DropdownItem key={value} value={value} label={localizeEnum('RateType', value)} />)
        );
    return (
        <FormSelectField
            name={DetailsFieldName.Type}
            label={<LocalizedText textKey={TextKey.RateVisibility} />}
            required
        >
            {renderRateTypeItems()}
        </FormSelectField>
    );
};
